export default __webpack_public_path__ + "static/media/check-payment.8ce2314c.svg";